<template>
  <div class="question">
    <p class="question-txt">{{ questionData.question }}</p>
    <p class="instructions" v-if="questionData.instructions != undefined">{{ questionData.instructions }}</p>
    <div class="question__body">
      <div v-for="(question, index) in questionData.questions" :key="index">
        <div class="group-header">
          {{ question.title }} <span v-if="question.titleExample">{{ question.titleExample }}</span>
        </div>

        <el-checkbox-group v-model="questionData.questions[index].selected" @change="updateStore">
          <el-checkbox-button v-for="(option, index) in question.options" :label="option.label" :key="index">{{ option.label }}</el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>

    <div class="question-footer">
      <Btn class="next-btn" type="primary-orange" theme="white" :hasIcon="false" @click="next">Next</Btn>
    </div>
  </div>
</template>

<script>
import { CheckboxGroup, CheckboxButton } from 'element-ui'
import Btn from '@/components/Btn'

export default {
  name: 'Question1',
  metaInfo() {
   // if no subcomponents specify a metaInfo.title, this title will be used
   return {
     title: 'Examine your eating',
     titleTemplate: ' %s - Question 1'
   }
  },
  props: [],
  components: {
    'el-checkbox-group': CheckboxGroup,
    'el-checkbox-button': CheckboxButton,
    Btn
  },
  data() {
    return {

    }
  },
  computed: {
    questionData() {
      return this.$store.state.DietImpact.questions[0]
    },
    breakfastTotals() {
      var count = 0
      for (var i = 0; i < this.questionData.questions.length; i++) {
        if (this.questionData.questions[i].selected.includes('Breakfast')) {
          count += this.questionData.questions[i].options[0].val
        }
      }
      return count
    },
    lunchTotals() {
      var count = 0
      for (var i = 0; i < this.questionData.questions.length; i++) {
        if (this.questionData.questions[i].selected.includes('Lunch')) {
          count += this.questionData.questions[i].options[1].val
        }
      }
      return count
    },
    dinnerTotals() {
      var count = 0
      for (var i = 0; i < this.questionData.questions.length; i++) {
        if (this.questionData.questions[i].selected.includes('Dinner')) {
          count += this.questionData.questions[i].options[2].val
        }
      }
      return count
    },
    snackTotals() {
      var count = 0
      for (var i = 0; i < this.questionData.questions.length; i++) {
        if (this.questionData.questions[i].selected.includes('Snack')) {
          count += this.questionData.questions[i].options[3].val
        }
      }
      return count
    },
    meatTotals() {
      let arr = this.questionData.questions[0]
      var count = 0
      // For each meal time selected (i.e. breakfast, lunch, dinner etc)
      for (var i = 0; i < arr.selected.length; i++) {
        let selected = arr.selected[i]
        // Get selected meal time's value
        for (var k = 0; k < arr.options.length; k++) {
          if (arr.options[k].label.includes(selected)) {
            count += arr.options[k].val
          }
        }
      }
      return count
    }
  },
  methods: {
    next() {
      // Check if user eats meat
      if (this.meatTotals > 0) {
        this.$store.commit('DietImpact/NEXT_PAGE')
      } else { // User doesn't eat meat so skip to question 4
        this.$store.commit('DietImpact/SKIP_QUESTIONS')
      }
      this.$parent.$parent.$refs.quiz.scrollTo({ top: 0, behavior: 'smooth' });
    },
    updateStore() {
      this.$store.commit('DietImpact/UPDATE_QUESTION_ONE', this.questionData)
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/vars';

.group-header {
  font-family: $fPrimary;
  font-weight: $fwSemiBold;
  font-size: 14px;
  line-height: 17px;
  span {
    font-weight: $fwMed;
  }
}

.el-checkbox-group {
  margin-top: 16px;
  margin-bottom: 30px;
}
.el-checkbox-button {
  margin-right: 12px;
  margin-bottom: 10px;
  &:last-of-type {
    margin-right: 0;
  }
}

.el-checkbox-button__inner {
  padding: 8px 16px;
  font-family: $fSecondary;
  font-weight: $fwMed;
  font-size: 12px;
  line-height: 19px;
  text-transform: uppercase;
  border: 1px solid #DADADA;
  color: #696969;
  border-radius: 5px;
  @media (min-width: 380px) {
    font-size: 13px;
  }
}

.el-checkbox-button:first-child .el-checkbox-button__inner,
.el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 5px;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner,
.el-checkbox-button.is-checked:first-child .el-checkbox-button__inner,
.el-checkbox-button.is-checked:last-child .el-checkbox-button__inner {
  background-color: $cOrange;
  border-color: $cOrange;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
  box-shadow: none;
}

.el-checkbox-button__inner:hover {
  color: $cOrange;
}

</style>
